import React, { useState } from 'react';
import "../components/Styles/Project2.css";

const projects = [
    {
    title: 'POTHOLE DETECTION AND FILLING ',
    image: '/img/indprojects/ind23/ind23-1.jpg',
    description: 'This system is a semi-autonomous bot designed to detect and repair road surface damage, ensuring safer and smoother travel. Equipped with ultrasonic sensors, it identifies potholes and uses servo motors to accurately fill them, followed by a roller to stabilize the surface. By integrating technology, precision, and sustainability, it enhances road safety, reduces accidents, and optimizes maintenance efforts.',
  },
    {
    title: 'SMART JACKET FOR SPECIAL FORCES',
    image: '/img/indprojects/ind23/ind23-1.jpg',
    description:'This project introduces a smart jacket designed for soldiers operating in extreme climatic conditions, integrating IoT-based sensors to monitor vital signs such as body temperature and pulse rate in real time for continuous health tracking and safety. It also incorporates an adaptive temperature control system using a Peltier module to regulate body temperature according to environmental conditions, ensuring comfort in harsh environments. By combining health monitoring with intelligent climate control, the jacket enhances the efficiency, safety, and survivability of soldiers in challenging terrains. ',
  },
    {
    title: 'GARBAGE COLLECTION ',
    image: '/img/indprojects/ind23/ind23-1.jpg',
    description:'This project introduces an autonomous TrashBot equipped with radar technology, ultrasonic sensors, and PIR sensors to detect and collect waste efficiently. By distinguishing between humans and trash, the bot ensures seamless navigation in urban environments. With servo motors, a conveyor belt, and a plastic container, it effectively picks up and disposes of waste, promoting cleaner and smarter cities ',
  },
    {
    title: 'FOREST FIRE DETECTION AND PREVENTION',
    image: '/img/indprojects/ind23/ind23-1.jpg',
    description:'This project develops an advanced wildfire detection and prevention solution using satellite imaging, IoT sensors, drones, and machine learning. By providing real-time monitoring of environmental conditions, the system detects fire risks early, enabling faster response times. It also integrates predictive analytics for proactive fire management, ensuring the protection of ecosystems from the devastating effects of forest fires. ',
    },
    {
    title: 'THE SMART AGRICULTURE LINE FOLLOWING BOT',
    image: '/img/indprojects/ind23/ind23-1.jpg',
    description:'This project introduces an autonomous bot designed to enhance agricultural productivity by monitoring soil moisture, weather conditions, and crop health. Using a line-following mechanism and advanced sensors, the bot systematically navigates fields, performs essential irrigation tasks, and provides farmers real-time data. This smart system aims to foster sustainable and efficient farming practices by optimizing resource use. ',
  },
    {
    title: 'EMERGENCY SAFETY VEST',
    image: '/img/indprojects/ind23/ind23-1.jpg',
    description:'The proposed system addresses the critical challenge of monitoring the safety of emergency personnel during disaster situations. The Emergency Safety Vest integrates advanced sensors and communication technologies to track vital parameters such as heart rate, body temperature, blood oxygen levels (SpO2), and environmental conditions like harmful gases. ',
  },
    {
    title: 'STERIBOT',
    image: '/img/indprojects/ind23/ind23-1.jpg',
     description:' This project introduces a semi-autonomous robot designed for medical waste collection and segregation in healthcare settings. Controlled via Bluetooth, it features an arm for waste handling, sensors for metal detection, and ultrasonic sensors to monitor waste levels. The robot uses an ESP32 CAM module for obstacle detection and path monitoring',
  },
    {
    title: 'AUTOMOW NEXUS',
    image: '/img/indprojects/ind23/ind23-1.jpg',
    description:'The Smart Grass Cutter with Lawn Coverage is an automated lawn mower that enhances lawn maintenance efficiency. It employs a robotic vehicle with a high RPM grass cutter blade, microcontroller-based circuit, and ultrasonic sensors for systematic mowing in a zigzag pattern. The mower intelligently detects corners and edges, ensuring complete coverage of the lawn. ',
  },
   {
    title: 'AFIRE QUENCHER',
    image: '/img/indprojects/ind23/ind23-1.jpg',
    description:'Fire Quencher is an autonomous fire-sensing and extinguishing robot designed to detect and respond to fire outbreaks efficiently. Equipped with multiple flame sensors, a PIR sensor for human detection, and a water pump system, it navigates towards fire-affected areas, either manually or autonomously, ensuring quick suppression and enhancing safety while minimizing property damage. ',
   },
   {
    title: 'SMART BRIDGE',
    image: '/img/indprojects/ind23/ind23-1.jpg',
    description:'An automatic height-adjusting bridge ensures safe passage during floods by raising or lowering in response to water levels. Equipped with an Arduino, moisture/water level sensor, and servo motor, it prevents structural damage and maintains accessibility. This dynamic design addresses flooding challenges and helps avert transportation delays or safety hazards. ',
   },
   {
    title: 'SANITRON ',
    image: '/img/indprojects/ind23/ind23-1.jpg',
    description:'SANITRON is an autonomous sanitization robot designed to disinfect train compartments efficiently. Using infrared sensors for obstacle detection, a NodeMCU microcontroller for navigation, and motor drivers for controlled sanitizer dispersion, it ensures thorough, automated cleaning. This innovation reduces reliance on manual labour and minimizes disease transmission in crowded trains.',
   },
   {
    title: 'AUTOMATIC ROOFING SYSTEM ',
    image: '/img/indprojects/ind23/ind23-1.jpg',
    description:'This Automatic Roofing System shields crops from heavy rainfall and conserves rainwater for reuse. Using rain and soil moisture sensors, it detects rainfall and activates a BO motor to deploy a polythene sheet over the field. Powered by Li-ion batteries, it protects crops from damage while promoting sustainable water management for irrigation and household use. ',
   },
   {
    title: 'VERTICAL FARMING BOT ',
    image: '/img/indprojects/ind23/ind23-1.jpg',
    description:'Vertical farming presents a sustainable solution to traditional agriculture, using robots to monitor and optimize plant growth. These robots are equipped with sensors to measure humidity, temperature, and other environmental parameters, transmitting data in real-time via ESP32. The robots utilize rack-and-pinion mechanisms for vertical mobility, ensuring thorough monitoring of all plant areas, including hard-to-reach ones. ',
   },
   {
    title: 'SOLAR POWER WATER TRASH COLLECTOR ',
    image: '/img/indprojects/ind23/ind23-1.jpg',
    description:'The solar-powered water trash collector is an eco-friendly solution for cleaning water bodies. It harnesses solar energy to power an autonomous system equipped with sensors, GPS, and AI to collect floating debris efficiently. By reducing reliance on fossil fuels and minimizing environmental impact, this innovative system helps maintain cleaner waterways and protects aquatic ecosystems. ',
   },
];

function Induction24() {
  const [popupData, setPopupData] = useState(null);

  const openPopup = (project) => {
    setPopupData(project);
  };

  const closePopup = () => {
    setPopupData(null);
  };

  return (
    <>
    <div className="header">
      <h1 className="head-title">Induction 2024</h1>
    </div>
    <div className="projects-wrapper">
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div
            key={index}
            className="project-card"
            onClick={() => openPopup(project)}
          >
            <div className="project-img">
              <img src={project.img} alt={project.title} />
            </div>
            <div className="project-title">{project.title}</div>
          </div>
        ))}
      </div>

      {popupData && (
        <div className="popup" style={{ display: 'flex' }}>
          <div className="popup-content">
            <span className="close-btn" onClick={closePopup}>×</span>
            <img src={popupData.img} alt="Popup" />
            <h5>{popupData.title}</h5>
            <p>{popupData.description}</p>
          </div>
        </div>
      )}
    </div>
    </>
  );
}

export default Induction24;